import React, { FC } from 'react';

export type ButtonType = {
  type: 'button' | 'submit';
};

type ButtonProps = {
  buttonStyle: string;
  text: string;
  buttonType: ButtonType;
  hasImage: boolean;
  pointer?: React.ReactElement;
  onClick?: () => void;
  disabled?: boolean;
  tooltipText?: string;
};

const Button: FC<ButtonProps> = ({
  buttonStyle,
  text,
  buttonType,
  hasImage,
  pointer,
  onClick,
  disabled = false,
  tooltipText,
}: ButtonProps) => {
  const buttonContent = (
    <button
      type={buttonType.type}
      className={`${buttonStyle} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      <span>{text}</span>
      {hasImage && <div>{pointer}</div>}
    </button>
  );

  if (tooltipText) {
    return (
      <div className="relative group inline-block">
        {buttonContent}
        <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 z-10 whitespace-nowrap">
          {tooltipText}
        </span>
      </div>
    );
  }

  return buttonContent;
};

export default Button;
